export const FETCH_CHARACTERS_REQUEST = 'FETCH_CHARACTER_REQUEST';
export const FETCH_CHARACTERS_SUCCESS = 'FETCH_CHARACTER_SUCCESS';
export const FETCH_CHARACTERS_FAILURE = 'FETCH_CHARACTER_FAILURE';
